import { type SxProps, type Theme } from '@mui/material';

export const sidekickPaneSx: SxProps<Theme> = {
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
  position: 'relative',
};

export const sidekickSubtabsSx: SxProps<Theme> = {
  flexShrink: 0,
  minHeight: 'unset',
  marginBottom: '0.625rem',
  borderBottom: (theme) => `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
  // one pixel low, so the underline covers the strip's divider
  '& .MuiTabs-indicator': {
    height: '0.125rem',
    bottom: '-0.0625rem',
    backgroundColor: (theme) => theme.palette.custom.OV.sys.secondary,
  },
  '& .MuiTab-root': {
    flex: 1,
    minWidth: 0,
    minHeight: 'unset',
    padding: '0.625rem 0.25rem 0.75rem',
    fontSize: '0.6875rem',
    fontWeight: 700,
    letterSpacing: '0.1em',
    textTransform: 'uppercase',
    color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
    '&:hover': { color: (theme) => theme.palette.custom.OV.sys.onBackground },
    '&.Mui-selected': { color: (theme) => theme.palette.custom.OV.sys.secondary },
  },
};

export const sidekickPaneContentSx = ({
  shouldShowLiveTranscription,
  isLiveTranscriptVisible,
}: {
  shouldShowLiveTranscription: boolean;
  isLiveTranscriptVisible: boolean;
}): SxProps<Theme> => {
  const shouldUseTranscriptSpacing = shouldShowLiveTranscription && isLiveTranscriptVisible;

  return {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    position: 'relative',
    px: 1,
    pb: shouldUseTranscriptSpacing ? '4rem' : '0.3125rem',
  };
};
